// extracted by mini-css-extract-plugin
module.exports = {"container":"em","content":"en","text":"eo","title":"ep","link":"eq","info":"er","actions":"es","button":"et"};